import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Menu from './src/menu'
import MenuItem from './src/menu-item.vue'
import MenuItemGroup from './src/menu-item-group.vue'
import SubMenu from './src/sub-menu'

export const JdMenu = withInstall(Menu, {
  MenuItem,
  MenuItemGroup,
  SubMenu,
})
export default JdMenu
export const JdMenuItem = withNoopInstall(MenuItem)
export const JdMenuItemGroup = withNoopInstall(MenuItemGroup)
export const JdSubMenu = withNoopInstall(SubMenu)

export * from './src/menu'
export * from './src/menu-item'
export * from './src/menu-item-group'
export * from './src/sub-menu'
export * from './src/types'
